import React, { useState, useEffect } from 'react';
import HeroBanner from '../components/HeroBanner';
import TrustBar from '../components/TrustBar';
import CategorySection from '../components/CategorySection';
import PromoBanner from '../components/PromoBanner';
import ProductCard from '../components/ProductCard';
import RecommendedProducts from '../components/RecommendedProducts';
import ComboSection from '../components/ComboSection';
import SEOHead from '../components/SEOHead';
import { useBreakpoint } from '../hooks/useBreakpoint';
import api from '../api/axios';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://www.a1looks.com';

const HOME_JSON_LD = [
  {
    '@type': 'WebSite',
    url: SITE_URL,
    name: 'A1 Looks',
    description: 'Handcrafted Indian Style for Every Occasion — Punjabi Juttis, Jewellery & Accessories',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/shop?search={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@type': 'Organization',
    name: 'A1 Looks',
    url: SITE_URL,
    logo: `${SITE_URL}/logo192.png`,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+91-7042544844',
      contactType: 'customer service',
      areaServed: 'IN',
      availableLanguage: 'English',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Neo Town Road',
      addressLocality: 'Bangalore',
      postalCode: '560100',
      addressCountry: 'IN',
    },
    sameAs: [],
  },
];

function ProductGrid({ title, subtitle, params, limit = 8 }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isMobile } = useBreakpoint();

  useEffect(() => {
    api.get(`/products/?${params}&page_size=${limit}`)
      .then(res => setProducts(res.data.results || res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [params, limit]);

  if (loading) return (
    <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>Loading {title}…</div>
  );
  if (!products.length) return null;

  return (
    <section style={{ padding: isMobile ? '40px 16px' : '60px 24px', maxWidth: 1200, margin: '0 auto' }}>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: isMobile ? 24 : 32, color: '#2C2C2C', textAlign: 'center', marginBottom: 8 }}>
        {title}
      </h2>
      {subtitle && <p style={{ textAlign: 'center', color: '#888', marginBottom: isMobile ? 24 : 40, fontSize: 15 }}>{subtitle}</p>}
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(240px, 1fr))', gap: isMobile ? 12 : 24 }}>
        {products.map(p => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <div>
      <SEOHead
        title="A1 Looks — Handcrafted Punjabi Juttis & Ethnic Jewellery"
        description="Shop authentic Punjabi Juttis, Kundan jewellery, earrings, necklaces and ethnic accessories. Handcrafted by Indian artisans. Free shipping above ₹999. COD available."
        canonical={SITE_URL}
        jsonLd={HOME_JSON_LD}
      />
      <HeroBanner />
      <TrustBar />
      <ProductGrid
        title="Best Sellers"
        subtitle="Our most loved pieces, chosen by you"
        params="is_best_seller=true"
        limit={8}
      />
      <CategorySection />
      <PromoBanner />
      <ComboSection />
      <ProductGrid
        title="New Arrivals"
        subtitle="Fresh styles just landed"
        params="is_new_arrival=true"
        limit={8}
      />
      <RecommendedProducts />
    </div>
  );
}
